import axios from 'axios';
import { WEB_VITAL_URL } from './utils/RailsSEOConstants';

export function addToMetricQueue(metric, metricQueue) {
  metricQueue.add(metric);
}

export function flushMetricQueue(metricQueue, pageInfo) {
  const { template_name, pageUrl } = pageInfo;

  if (metricQueue.size > 0) {
    const metricRequestData = {
      templateName: template_name,
      pageUrl,
      metricData: [...metricQueue]
    };

    // eslint-disable-next-line no-console
    axios.post(WEB_VITAL_URL, metricRequestData).catch((err) => console.error('[web-vitals/error]', err));

    metricQueue.clear();
  }
}
